import type { ReportDocument } from '@codepass/shared';
import { BarChart } from '@/components/domain';
import { Card, CardBody, CardHeader, CardTitle } from '@/components/ui';

/**
 * The bars on /rapporter/fakturering-pr-maaned: the year's twelve months against their budget -
 * the dashboard's "Fakturering pr. måned", for the whole year. Drawn from the report's own
 * `months` section, so the bars and the table below cannot say different things.
 */
export function BillingByMonthChart({ report }: { report: ReportDocument }) {
  const months = report.sections.find((section) => section.id === 'months');
  if (!months || months.rows.length === 0) return null;

  const items = months.rows.map((row) => ({
    label: String(row.month ?? ''),
    // Null for a month that has not begun - the table's dash, not a 0.
    value: typeof row.billed === 'number' ? row.billed : null,
    reference: typeof row.budget === 'number' ? row.budget : null,
  }));
  const withBudget = items.some((item) => item.reference !== null);

  return (
    <Card className="mb-5">
      <CardHeader>
        <CardTitle>Faktureret mod budget, {report.year}</CardTitle>
        <p className="mt-1 text-xs text-ink-muted">
          {withBudget
            ? 'Bogført ekskl. moms. Stregen er månedens budget i Business Central.'
            : `Bogført ekskl. moms. Business Central har intet budget for ${report.year}.`}
        </p>
      </CardHeader>
      <CardBody>
        <BarChart items={items} />
      </CardBody>
    </Card>
  );
}
